import { render, staticRenderFns } from "./serverRetire.vue?vue&type=template&id=705c613a&scoped=true"
import script from "./serverRetire.vue?vue&type=script&lang=js"
export * from "./serverRetire.vue?vue&type=script&lang=js"
import style0 from "./serverRetire.vue?vue&type=style&index=0&id=705c613a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c613a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705c613a')) {
      api.createRecord('705c613a', component.options)
    } else {
      api.reload('705c613a', component.options)
    }
    module.hot.accept("./serverRetire.vue?vue&type=template&id=705c613a&scoped=true", function () {
      api.rerender('705c613a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/dcopsTicket/serverRetire.vue"
export default component.exports